import {
  getItemLocalStorage,
  removeBaseFromIndexedDB,
  setItemLocalStorage,
} from "@utils/function";

export default function OfflineMap() {
  if (!HQ.Properties.golfCourseTiles || HQ.Properties.leafletoffline !== "1")
    return;

  const offlineMapStorage = getItemLocalStorage("HQofflineMap");

  // for testing purpose
  // const "HQofflineMap" = "HQofflineMap";

  // check if local storage exist
  if (offlineMapStorage) {
    // check if item exist in array
    const index = offlineMapStorage.indexOf(HQ.Properties.appId);
    if (index === -1) {
      // add new item to the beginning of an array
      offlineMapStorage.unshift(HQ.Properties.appId);
      // save to local storage
      setItemLocalStorage("HQofflineMap", offlineMapStorage);
    }

    // get array length
    const OfflineMapLength = offlineMapStorage.length;
    // check if array length is bigger than 4
    if (OfflineMapLength > 4) {
      // remove last item
      const baseName = offlineMapStorage.pop();
      // save to local storage
      setItemLocalStorage("HQofflineMap", offlineMapStorage);

      // remove from indexedDB if exist
      removeBaseFromIndexedDB(baseName);
    }
  } else {
    // create new array if not exist
    setItemLocalStorage("HQofflineMap", [HQ.Properties.appId]);
  }
}
